import React, { useRef, useState } from "react";
import "./Booking.css";
import { Col, Row, Form } from "react-bootstrap";
import DronImage from "../../assets/images/png/mine.png";
import calendarImg from "../../assets/images/svg/calender.svg";
import Calendar from "react-calendar";
import FeatureAdds from "../AllProdutcs/FeatureAdds";
import { ToastContainer, toast } from "react-toastify";
import { DroneBookingForm } from "../../services/DroneServices";
import {
  GoogleMap,
  Marker,
  useJsApiLoader,
  Autocomplete,
} from "@react-google-maps/api";
import trashIcon from "../../assets/images/png/trash.png";

const Booking = () => {
  const [value, setValue] = useState(null);
  const [showCalendar, setShowCalendar] = useState(false);
  const [autocomplete, setAutocomplete] = useState(null);
  const searchInputRef = useRef(null);
  const [individualData, setIndividualData] = useState({
    name: "",
    number: "",
    state: "",
    district: "",
    serviceDate: "",
    serviceTime: "",
    farmLocation: {
      lat: 28.6139,
      lng: 77.209,
    },
    farms: [{ name: "", acres: "" }],
    cropType: "",
    cropStage: "",
    agrochemical: "",
    agrochemicalForm: "",
  });

  const formatFarmLocation = () => {
    const { lat, lng } = individualData.farmLocation;
    return `Lat: ${lat}, Lng: ${lng}`;
  };

  const handleIndividualDataChange = (e) => {
    const { name, value } = e.target;
    setIndividualData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: "AIzaSyB2RtewitkS39nshoT7sX62vUpsL6eZ7VA",
    libraries: ["places"],
  });

  const onMapClick = (event) => {
    setIndividualData((prevState) => ({
      ...prevState,
      farmLocation: {
        lat: event.latLng.lat(),
        lng: event.latLng.lng(),
      },
    }));
  };

  const onMarkerDragEnd = (event) => {
    setIndividualData((prevState) => ({
      ...prevState,
      farmLocation: {
        lat: event.latLng.lat(),
        lng: event.latLng.lng(),
      },
    }));
  };

  const onLoadAutocomplete = (autocompleteInstance) => {
    setAutocomplete(autocompleteInstance);
  };

  const onPlaceChanged = () => {
    if (autocomplete) {
      const place = autocomplete.getPlace();
      if (place.geometry) {
        setIndividualData((prevState) => ({
          ...prevState,
          farmLocation: {
            lat: place.geometry.location.lat(),
            lng: place.geometry.location.lng(),
          },
        }));
      }
    }
  };

  const handleFarmChange = (index, e) => {
    const { name, value } = e.target;
    const updatedFarms = [...individualData.farms];
    updatedFarms[index][name] = value;
    setIndividualData((prevState) => ({
      ...prevState,
      farms: updatedFarms,
    }));
  };

  const addFarm = () => {
    setIndividualData((prevState) => ({
      ...prevState,
      farms: [...prevState.farms, { name: "", acres: "" }],
    }));
  };

  const isFormValid = () => {
    const requiredFields = [
      "name",
      "number",
      "state",
      "district",
      "serviceDate",
      "serviceTime",
      "farmLocation",
    ];
    return (
      requiredFields.every((field) => individualData[field] !== "") &&
      individualData.farms.every((farm) => farm.name && farm.acres) &&
      individualData.cropType &&
      individualData.cropStage &&
      individualData.agrochemical &&
      individualData.agrochemicalForm
    );
  };
  const containerStyle = {
    width: "100%",
    height: "200px",
    borderRadius: "12px",
  };

  const sendContractorData = async () => {
    if (!isFormValid()) {
      toast.error("Please fill in all required fields");
      return;
    }

    // Combine date and time into a single Date object
    const serviceDateTime = new Date(
      `${individualData.serviceDate.toISOString().split("T")[0]}T${
        individualData.serviceTime
      }`
    );

    const data = {
      name: individualData.name,
      phoneNumber: individualData.number,
      state: individualData.state,
      district: individualData.district,
      serviceDateTime: serviceDateTime,
      farmLocation: individualData.farmLocation,
      farms: individualData.farms.map((farm) => ({
        farmName: farm.name,
        acres: Number(farm.acres),
      })),
      cropType: individualData.cropType,
      cropStage: individualData.cropStage,
      agrochemical: individualData.agrochemical,
      agrochemicalForm: individualData.agrochemicalForm,
    };

    try {
      const response = await DroneBookingForm(data);
      if (response.status === "success") {
        if (searchInputRef.current) {
          searchInputRef.current.value = "";
        }
        setIndividualData({
          name: "",
          number: "",
          state: "",
          district: "",
          serviceDate: "",
          serviceTime: "",
          farmLocation: {
            lat: 28.6139,
            lng: 77.209,
          },
          farms: [{ name: "", acres: "" }],
          cropType: "",
          cropStage: "",
          agrochemical: "",
          agrochemicalForm: "",
        });
        toast.success("Form submitted successfully");
      } else {
        toast.error("Something went wrong");
      }
    } catch (error) {
      toast.error("Something went wrong");
    }
  };

  const formatDate = (timestamp) => {
    if (!timestamp) {
      return "Select a date";
    }
    const date = new Date(timestamp);
    return date.toLocaleDateString("en-US", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
  };

  const defaultLocation = { lat: 28.6139, lng: 77.209 };
  const center = individualData.farmLocation || defaultLocation;

  const removeFarm = (index) => {
    const updatedFarms = individualData.farms.filter((_, i) => i !== index);
    setIndividualData({ ...individualData, farms: updatedFarms });
  };
  return (
    <div className="bg_clr_light_green pb-5 pt-4">
      <ToastContainer />
      <div
        onClick={() => setShowCalendar(false)}
        className={`over-lay position-fixed ${
          showCalendar ? "d-block" : "d-none"
        }`}
      ></div>
      <div className="container">
        <Row>
          <Col lg={9}>
            <div>
              <img
                src={DronImage}
                className="w-100 drone-req-hero-img object-fit-cover"
                alt="Drone"
              />
            </div>
            <div className="mt-4 p-lg-5 p-4 bg-white rounded-2 position-relative">
              <h2 className="mb-0 ff_heebo fw-bold clr_dark_blue fs_7xl">
                <span className="text-green">Drone </span>
                Booking Form
              </h2>
              <p className="text-dark-grey mb-0 ff_heebo fs_xsm mt-2">
                Book Your Drone by filling up the Details
              </p>
              <Form>
                <div className="mt-4 d-flex flex-column gap-3">
                  <div className="d-flex flex-wrap gap-4 align-items-center">
                    <input
                      className="register-inputs px-3 clr_dark_grey_4"
                      type="text"
                      placeholder="Name *"
                      name="name"
                      value={individualData.name}
                      onChange={handleIndividualDataChange}
                    />
                    <input
                      className="register-inputs px-3 clr_dark_grey_4"
                      type="text"
                      placeholder="Phone Number *"
                      name="number"
                      maxLength="16"
                      value={individualData.number}
                      onChange={(e) => {
                        const re = /^[0-9\b]+$/;
                        if (e.target.value === "" || re.test(e.target.value)) {
                          handleIndividualDataChange(e);
                        }
                      }}
                    />
                  </div>
                  <div className="d-flex flex-wrap gap-4 align-items-center">
                    <input
                      className="register-inputs px-3 clr_dark_grey_4"
                      type="text"
                      placeholder="State *"
                      name="state"
                      value={individualData.state}
                      onChange={handleIndividualDataChange}
                    />
                    <input
                      className="register-inputs px-3 clr_dark_grey_4"
                      type="text"
                      placeholder="District *"
                      name="district"
                      value={individualData.district}
                      onChange={handleIndividualDataChange}
                    />
                  </div>
                  <div className="d-flex flex-wrap gap-4 align-items-center">
                    <div
                      onClick={() => setShowCalendar(true)}
                      className="d-flex align-items-center date-input-div cursor-pointer w-100"
                    >
                      <input
                        className="register-inputs bg-transparent border-0 px-3 clr_dark_grey_4"
                        type="text"
                        value={formatDate(individualData.serviceDate)}
                        placeholder="Select Date *"
                        disabled
                      />
                      <img
                        className="border-0"
                        src={calendarImg}
                        alt="calendar"
                      />
                      {showCalendar && (
                        <div className="position-fixed date-calendar z-2">
                          <Calendar
                            value={value}
                            minDate={new Date()}
                            onClickDay={(date) => {
                              setValue(date);
                              setIndividualData((prevState) => ({
                                ...prevState,
                                serviceDate: date,
                              }));
                              setShowCalendar(false);
                            }}
                          />
                        </div>
                      )}
                    </div>
                    <input
                      className="register-inputs px-3 clr_dark_grey_4"
                      type="time"
                      placeholder="Select Time *"
                      name="serviceTime"
                      value={individualData.serviceTime}
                      onChange={handleIndividualDataChange}
                    />
                  </div>
                  <input
                    className="register-inputs px-3 clr_dark_grey_4"
                    type="hidden"
                    placeholder="Farm Location (CAPTURE GEOLOCATION) *"
                    name="farmLocation"
                    value={formatFarmLocation()}
                    onChange={handleIndividualDataChange}
                    readOnly
                  />
                  <div className="mt-4">
                    <p>Pin your farm location</p>
                    {isLoaded ? (
                      <div style={{ position: "relative" }}>
                        <GoogleMap
                          mapContainerStyle={containerStyle}
                          center={center}
                          zoom={10}
                          onClick={onMapClick}
                        >
                          <Marker
                            position={individualData.farmLocation}
                            draggable
                            onDragEnd={onMarkerDragEnd}
                          />
                        </GoogleMap>
                        <div
                          style={{
                            position: "absolute",
                            top: 10,
                            left: 1,
                            zIndex: 1,
                            maxWidth: "300px",
                          }}
                          className="w-100 px-2 rounded-2"
                        >
                          <Autocomplete
                            onLoad={onLoadAutocomplete}
                            onPlaceChanged={onPlaceChanged}
                          >
                            <input
                              type="text"
                              placeholder="Search your farm location"
                              className="register-inputs px-3 clr_dark_grey_4 rounded-2"
                              ref={searchInputRef}
                            />
                          </Autocomplete>
                        </div>
                      </div>
                    ) : (
                      <p>Loading map...</p>
                    )}
                  </div>
                  {individualData.farms.map((farm, index) => (
                    <div
                      key={index}
                      className="d-flex gap-4 flex-wrap align-items-center"
                    >
                      <input
                        className="register-inputs-3 px-3 clr_dark_grey_4"
                        type="text"
                        placeholder="Farm Name *"
                        name="name"
                        value={farm.name}
                        onChange={(e) => handleFarmChange(index, e)}
                      />
                      <input
                        className="register-inputs-3 px-3 clr_dark_grey_4"
                        type="number"
                        placeholder="Acres *"
                        name="acres"
                        value={farm.acres}
                        onChange={(e) => handleFarmChange(index, e)}
                      />
                      {individualData.farms.length > 1 && (
                        <button
                          type="button"
                          onClick={() => removeFarm(index)}
                          className="bg-transparent border-0 remove-farm-button"
                        >
                          <img
                            style={{ width: "20px" }}
                            src={trashIcon}
                            alt="trashIcon"
                          />
                        </button>
                      )}
                    </div>
                  ))}

                  <button
                    type="button"
                    onClick={addFarm}
                    className="common-darkgreen-button text-white rounded-2 mt-3 add-another-farm"
                  >
                    Add Another Farm
                  </button>

                  <div className="d-flex flex-wrap gap-4 align-items-center">
                    <select
                      className="register-inputs px-3 clr_dark_grey_4"
                      name="cropType"
                      value={individualData.cropType}
                      onChange={handleIndividualDataChange}
                    >
                      <option value="">Select Crop Type *</option>
                      <option value="Sugarcane">Sugarcane</option>
                      <option value="Cotton">Cotton</option>
                      <option value="Rice">Rice</option>
                      <option value="Wheat">Wheat</option>
                      <option value="Other Field Crops">
                        Other Field Crops
                      </option>
                      <option value="Fruit">Fruit</option>
                      <option value="Vegetables">Vegetables</option>
                      <option value="Oilseed">Oilseed</option>
                      <option value="Plantation">Plantation</option>
                    </select>
                    <select
                      className="register-inputs px-3 clr_dark_grey_4"
                      name="cropStage"
                      value={individualData.cropStage}
                      onChange={handleIndividualDataChange}
                    >
                      <option value="">Select Crop Stage *</option>
                      <option value="Seedling Stage">Seedling Stage </option>
                      <option value="Growth Stage">Growth Stage </option>
                      <option value="Flowering Stage">Flowering Stage </option>
                      <option value="Fruiting Stage">Fruiting Stage </option>
                      <option value="Ripening Stage">Ripening Stage </option>
                    </select>
                  </div>
                  <div className="d-flex flex-wrap gap-4 align-items-center">
                    <select
                      className="register-inputs px-3 clr_dark_grey_4"
                      name="agrochemical"
                      value={individualData.agrochemical}
                      onChange={handleIndividualDataChange}
                    >
                      <option value="">Select Agrochemical *</option>
                      <option value="Pesticide">Pesticide</option>
                      <option value="Weedicide">Weedicide</option>
                      <option value="Liquid Fertilizer">
                        Liquid Fertilizer
                      </option>
                      <option value="Herbicide">Herbicide</option>
                      <option value="Growth Promoter">Growth Promoter</option>
                    </select>
                    <select
                      className="register-inputs px-3 clr_dark_grey_4"
                      name="agrochemicalForm"
                      value={individualData.agrochemicalForm}
                      onChange={handleIndividualDataChange}
                    >
                      <option value="">Select Agrochemical Form *</option>
                      <option value="Liquid">Liquid</option>
                      <option value="Granules">Granules</option>
                      <option value="Powder">Powder</option>
                      <option value="Ultra Low Volume (ULV)">
                        Ultra Low Volume (ULV)
                      </option>
                      <option value="Other">Other</option>
                    </select>
                  </div>
                  <button
                    style={{ height: "45px" }}
                    type="button"
                    onClick={sendContractorData}
                    className="common-darkgreen-button text-white rounded-2 mt-3"
                  >
                    Submit Booking
                  </button>
                </div>
              </Form>
            </div>
          </Col>
          <Col lg={3} className="d-lg-block d-none">
            <FeatureAdds />
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default Booking;
